module.exports = __webpack_public_path__ + "media/images/bg/404-bg-b8ba6bef3bbc330f8b28ca51685f69b8.jpg";